/**
 * 縦断測量成果および横断測量成果と線形 (Alignment) とのリレーショナル結合を実行します。
 * 縦断成果 (H00) または横断成果 (I00) の routeNumber が線形内のいずれかの路線の routeNumber と一致する場合、
 * その Alignment に結合します。一致しないブロックは孤立成果 (orphans) として収集し、対応する警告を出力します。
 */
export function linkProfilesAndCrossSections(alignments, profiles, crossSections) {
    const orphanProfiles = [];
    const orphanCrossSections = [];
    const warnings = [];
    for (const prof of profiles) {
        prof.sortStations();
        const matchedAlignment = alignments.find((a) => a.hasRouteNumber(prof.routeNumber));
        if (matchedAlignment) {
            matchedAlignment.linkProfile(prof);
        }
        else {
            orphanProfiles.push(prof);
            warnings.push({
                type: "ORPHAN_PROFILE",
                message: `Longitudinal Profile for route #${prof.routeNumber} (${prof.routeName}) has no matching F00 route in any alignment.`,
                record: `H00,${prof.routeNumber},${prof.routeName}`,
            });
        }
    }
    for (const cs of crossSections) {
        cs.sortStations();
        const matchedAlignment = alignments.find((a) => a.hasRouteNumber(cs.routeNumber));
        if (matchedAlignment) {
            matchedAlignment.linkCrossSections(cs);
        }
        else {
            orphanCrossSections.push(cs);
            warnings.push({
                type: "ORPHAN_CROSS_SECTION",
                message: `Cross Section group for route #${cs.routeNumber} (${cs.routeName}) has no matching F00 route in any alignment.`,
                record: `I00,${cs.routeNumber},${cs.routeName}`,
            });
        }
    }
    return {
        orphanProfiles,
        orphanCrossSections,
        warnings,
    };
}
/**
 * 孤立した縦断成果を、指定された線形の路線番号と照合して再結合します。
 * warnings 配列が渡された場合、解決された路線の ORPHAN_PROFILE 警告も併せて削除します。
 */
export function rematchOrphanProfiles(alignment, orphanProfiles, warnings) {
    const matched = [];
    for (let i = orphanProfiles.length - 1; i >= 0; i--) {
        const prof = orphanProfiles[i];
        if (alignment.hasRouteNumber(prof.routeNumber)) {
            orphanProfiles.splice(i, 1);
            alignment.linkProfile(prof);
            matched.push(prof);
            if (warnings) {
                for (let wIdx = warnings.length - 1; wIdx >= 0; wIdx--) {
                    const w = warnings[wIdx];
                    if (w.type === "ORPHAN_PROFILE" &&
                        (w.record === `H00,${prof.routeNumber},${prof.routeName}` ||
                            w.message.includes(`route #${prof.routeNumber}`))) {
                        warnings.splice(wIdx, 1);
                    }
                }
            }
        }
    }
    return matched;
}
/**
 * 孤立した横断成果を、指定された線形の路線番号と照合して再結合します。
 * warnings 配列が渡された場合、解決された路線の ORPHAN_CROSS_SECTION 警告も併せて削除します。
 */
export function rematchOrphanCrossSections(alignment, orphanCrossSections, warnings) {
    const matched = [];
    for (let i = orphanCrossSections.length - 1; i >= 0; i--) {
        const cs = orphanCrossSections[i];
        if (alignment.hasRouteNumber(cs.routeNumber)) {
            orphanCrossSections.splice(i, 1);
            alignment.linkCrossSections(cs);
            matched.push(cs);
            if (warnings) {
                for (let wIdx = warnings.length - 1; wIdx >= 0; wIdx--) {
                    const w = warnings[wIdx];
                    if (w.type === "ORPHAN_CROSS_SECTION" &&
                        (w.record === `I00,${cs.routeNumber},${cs.routeName}` ||
                            w.message.includes(`route #${cs.routeNumber}`))) {
                        warnings.splice(wIdx, 1);
                    }
                }
            }
        }
    }
    return matched;
}
//# sourceMappingURL=alignment-linker.js.map